import React, { useState } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { date, dateTime } from "../../../utils/dateTime";
import { useHistory } from "react-router";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
//image
import imageLanding from "../../../assets/images/landing-image-third.png";
//material
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import useStyle from "./style";
import TabPanel from "../../../components/TabPanel";
import { useMediaQuery, useTheme } from "@material-ui/core";
import EmptyOrder from "./EmptyOrder";
import currency from "../../../utils/currency";
import DetailDialog from "./DetailDialog";
import Gap from "../../../components/Gap";

function PreOrderItem({ order, preorderUtils }) {
  const classes = useStyle();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const handleBayar = async () => {
    try {
      const orderCreatePayment = firefunctions.httpsCallable(
        "order-createPayment"
      );
      const response = await orderCreatePayment({
        order_id: order.id,
      });

      if (response?.data?.token) {
        if (response?.data?.mode === "free") {
          return history.push(`/transaksi/transaksilist/sellerapp/tokorame`);
        } else {
          if (response?.data?.provider === "moota") {
            return history.push(`/moota/${response?.data?.token}`);
          } else {
            return history.push(`/payment/${response?.data?.token}`, {
              goBack: "/transaksi/transaksilist/sellerapp/tokorame",
            });
          }
        }
      } else {
        console.log(response.data);
        enqueueSnackbar(
          "Maaf Pelunasan belum bisa dilakukan, mohon coba lagi nanti.",
          { variant: "warning" }
        );
      }
    } catch (e) {
      console.log(e);
      enqueueSnackbar(
        "Maaf Pelunasan belum bisa dilakukan, mohon coba lagi nanti.",
        { variant: "warning" }
      );
    }
  };

  const startDate = preorderUtils?.down_payment_settlement_start_time;

  const endDate = preorderUtils?.down_payment_settlement_end_time;

  const nowDate = Date.now();
  const startDateTime = new Date(
    startDate?.seconds * 1000 + startDate?.nanoseconds / 1000000
  );
  const endDateTime = new Date(
    endDate?.seconds * 1000 + endDate?.nanoseconds / 1000000
  );
  const nowDateTime = new Date(nowDate);
  function isButtonActive(now, start, end) {
    return now.getTime() >= start.getTime() && now.getTime() <= end.getTime();
  }

  const buttonIsActive = isButtonActive(
    nowDateTime,
    startDateTime,
    endDateTime
  );

  const [dialog, setDialog] = useState({
    open: false,
    orderId: {},
  });

  const handleDetail = (e) => {
    setDialog({
      open: true,
      orderId: order.id,
    });
  };

  return (
    <>
      <Paper elevation={0} className={classes.wrapPaper}>
        <div onClick={handleDetail}>
          <div className={classes.wrapHeaderTitle}>
            <div>
              <Typography className={classes.liquidSecondList}>
                {date(order.created_at?.toDate?.())}
              </Typography>
            </div>
            <div className={classes.belumBayar}>
              <Brightness1Icon
                style={{ fontSize: "10px", color: "#4caf50", marginRight: "5" }}
              />
              <Typography className={classes.liquidSecondList}>
                Down Payment
              </Typography>
            </div>
          </div>
          <Divider />
          <div
            className={classes.wrapHeaderTitle}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <div>
              <CopyToClipboard
                text={order?.kode_order}
                onCopy={() => {
                  enqueueSnackbar("Kode Order Berhasil Disalin", {
                    variant: "success",
                  });
                }}
              >
                <Typography variant="caption" display="block">
                  <b>{order?.kode_order}</b>
                </Typography>
              </CopyToClipboard>{" "}
            </div>
            <div className={classes.belumBayar}>
              <FileCopyOutlinedIcon
                color="primary"
                style={{ width: "15", height: "15" }}
              />
            </div>
          </div>
          <div
            style={{
              backgroundColor: "#C7D9FF",
              padding: 10,
            }}
          >
            <div>
              <Typography className={classes.liquidPrimary}>
                Tanggal awal pelunasan
              </Typography>
              <Typography className={classes.liquidBold}>
                {dateTime(
                  preorderUtils?.down_payment_settlement_start_time?.toDate?.()
                )}
              </Typography>
            </div>
            <div>
              <Typography className={classes.liquidPrimary}>
                Tanggal akhir pelunasan
              </Typography>
              <Typography className={classes.liquidBold}>
                {dateTime(
                  preorderUtils?.down_payment_settlement_end_time?.toDate?.()
                )}
              </Typography>
            </div>
            <div>
              <Typography className={classes.liquidPrimary}>
                Total Pelunasan
              </Typography>
              <Typography className={classes.liquidBold}>
                {currency(order.total_pembayaran - order.total_nilai_dp)}
              </Typography>
            </div>
          </div>
        </div>
        <Divider />
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {preorderUtils?.down_payment_option && buttonIsActive && (
            <>
              <div style={{ padding: "10px" }}>
                <Typography className={classes.liquidSecond}>
                  Selesaikan Pembayaran. Pesananmu Menunggu Dibayar
                </Typography>
              </div>
              <div style={{ padding: "10px" }}>
                <Button
                  fullWidth
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleBayar}
                >
                  Bayar Sekarang
                </Button>
              </div>
            </>
          )}
        </div>
      </Paper>
      <Gap height={30} />
      <DetailDialog
        open={dialog.open}
        orderId={dialog.orderId}
        handleClose={() => {
          setDialog({
            open: false,
            orderId: {},
          });
        }}
      />
    </>
  );
}

function PreOrder({ value, modes }) {
  const { orders, preorderUtils } = useData();

  const DownPaymentOrders =
    orders
      ?.filter((order) => {
        return (
          modes === order.order_info?.location &&
          order.status === "paid" &&
          order.order_info.mode === "preorder" &&
          order.status_pengiriman === "waiting-for-settlement"
        );
      })
      .sort((a, b) => {
        const m2 = b.created_at?.toMillis?.() ?? 0;
        const m1 = a.created_at?.toMillis?.() ?? 0;

        return m2 - m1;
      }) ?? [];

  console.log("orders", DownPaymentOrders);
  return (
    <TabPanel
      style={{ backgroundColor: "#EFF1FE" }}
      value={value}
      index="preorder"
    >
      <div>
        {DownPaymentOrders && DownPaymentOrders.length > 0 ? (
          DownPaymentOrders?.map((item) => {
            return <PreOrderItem order={item} preorderUtils={preorderUtils} />;
          })
        ) : (
          <EmptyOrder />
        )}
      </div>
    </TabPanel>
  );
}

export default PreOrder;
